import { render, staticRenderFns } from "./DynPropOverview.vue?vue&type=template&id=59cb78b6"
import script from "./DynPropOverview.vue?vue&type=script&lang=js"
export * from "./DynPropOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports